import { ArrowLeft, ArrowRight } from "lucide-react";
import BackControls from "../components/BackControls";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/redux/hooks";
import type { Gender } from "../data/sharedTypes";
import StepHeader from "../StepHeader";

interface Props {
    universityNameKey: string;
    onBack: () => void;
    onSelectGender: (gender: Gender) => void;
}

const genderOptions: { id: Gender; icon: string }[] = [
    { id: "male", icon: "👨" },
    { id: "female", icon: "👩" },
];

export default function ChooseGender({ universityNameKey, onBack, onSelectGender }: Props) {
    const { t } = useTranslation();
    const { locale } = useAppSelector((state) => state);

    return (
        <div className="flex flex-col gap-y-6">
            <BackControls onBack={onBack} />

            <StepHeader
                title={t("dream_university_choose_gender")}
                subtitle={t(universityNameKey)}
            />

            <div className="w-full max-w-sm mx-auto flex flex-col gap-3">
                {genderOptions.map((option) => (
                    <button
                        key={option.id}
                        onClick={() => onSelectGender(option.id)}
                        className="w-full flex items-center gap-4 p-5 bg-white border-2 border-gray-200 rounded-2xl hover:border-theme-500 hover:shadow-lg transition-all duration-200 group"
                    >
                        <div className="w-12 h-12 bg-theme-100 rounded-xl flex items-center justify-center group-hover:bg-theme-200 transition-colors text-2xl">
                            {option.icon}
                        </div>
                        <span className="text-lg font-semibold text-gray-900">
                            {t(`dream_university_gender_${option.id}`)}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
}
